import type { RightPanelSurface } from "~/rightPanelStore";
import {
  createMappedWorkspaceSurface,
  type WorkspaceSurfaceContentMap,
} from "~/workspaceSurfaceContext";

export type RightPanelSurfaceContentMap = WorkspaceSurfaceContentMap<RightPanelSurface>;

const rightPanelSurfaceContent = createMappedWorkspaceSurface<RightPanelSurface>();

export const RightPanelSurfaceContentProvider = rightPanelSurfaceContent.Provider;
export const RightPanelSurfaceContent = rightPanelSurfaceContent.Surface;

/**
 * What a Region shows when a surface reaches the panel that nothing can fill: a tab persisted on
 * a device can outlive the thread state its content was gated on. Saying so is what lets the
 * reader close it, where a blank body reads as the panel itself being broken.
 */
export function RightPanelSurfaceUnavailable() {
  return (
    <div className="flex h-full flex-col items-center justify-center p-6 text-center">
      <p className="max-w-60 text-xs text-muted-foreground">
        This surface is not available for this thread. Close the tab to put it away.
      </p>
    </div>
  );
}
